import { render } from "./dispatch-sites.vue?vue&type=template&id=60633f0c&scoped=true"
import script from "./dispatch-sites.vue?vue&type=script&lang=js"
export * from "./dispatch-sites.vue?vue&type=script&lang=js"

import "./dispatch-sites.vue?vue&type=style&index=0&id=60633f0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60633f0c"]])

export default __exports__